import React from "react";

// Classes compartilhadas pelas telas admin (mesmo padrão da tela de Usuários).
export const INPUT =
  "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50";
export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90 disabled:opacity-50";
export const BTN_OUTLINE =
  "inline-flex items-center justify-center gap-2 rounded-md border border-border px-4 py-2 text-sm hover:bg-accent";

export function Toggle({ checked, onChange, label, description }) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-border p-4">
      <div className="space-y-0.5">
        <div className="text-sm font-medium">{label}</div>
        {description && <p className="text-xs text-muted-foreground">{description}</p>}
      </div>
      <button
        type="button"
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${checked ? "bg-emerald-500" : "bg-muted"}`}
      >
        <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${checked ? "translate-x-6" : "translate-x-1"}`} />
      </button>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div className="space-y-2">
      {label && <label className="text-sm font-medium">{label}</label>}
      {children}
    </div>
  );
}

export function ConfirmModal({ icon: Icon, iconClass, title, children, onClose, onConfirm, confirmLabel, confirmClass, loading }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="mx-4 w-full max-w-sm rounded-2xl border border-border bg-card shadow-xl">
        <div className="p-6 text-center">
          <div className={`mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full ${iconClass}`}>
            <Icon className="h-5 w-5" />
          </div>
          <h2 className="mb-2 text-lg font-semibold">{title}</h2>
          <p className="mb-6 text-sm text-muted-foreground">{children}</p>
          <div className="flex justify-center gap-3">
            <button onClick={onClose} className="rounded-md border border-border px-4 py-2 text-sm hover:bg-accent">
              Cancelar
            </button>
            <button onClick={onConfirm} disabled={loading} className={`rounded-md px-4 py-2 text-sm font-medium disabled:opacity-50 ${confirmClass}`}>
              {loading ? "..." : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Badges de status reutilizáveis.
export function ActiveBadge({ active, activeLabel, inactiveLabel = "Inativo" }) {
  if (active) {
    return activeLabel ? (
      <span className="inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300">
        {activeLabel}
      </span>
    ) : null;
  }
  return (
    <span className="inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/30 dark:text-red-300">
      {inactiveLabel}
    </span>
  );
}
